import Price from './Price';
import PricePerTime from './PricePerTime';

export default class MemberClubFee {
    static fromData(data) {
        if (!data) {
            return;
        }

        let memberClubFee = new MemberClubFee();
        memberClubFee.id = data.id;
        memberClubFee.clubFee = data.clubFee;
        memberClubFee.clubFeeId = data.clubFeeId;
        memberClubFee.clubFeeCategory = data.clubFeeCategory;
        if (null != data.invoiceRecipient) {
            memberClubFee.invoiceRecipient = {
                id: data.invoiceRecipient.id,
                name: data.invoiceRecipient.name,
            };
        }
        if (null != data.member) {
            memberClubFee.member = {
                id: data.member.id,
                name: data.member.name,
            };
        }
        memberClubFee.note = data.note;
        memberClubFee.chargeCredit = data.chargeCredit;
        memberClubFee.settleWithCredit = data.settleWithCredit;
        memberClubFee.department = data.department;
        memberClubFee.paymentMethod = data.paymentMethod;
        memberClubFee.archived = data.archived;
        if (null != data.quantityFactor) {
            memberClubFee.quantityFactor = {
                numerator: data.quantityFactor.data.numerator,
                denominator: data.quantityFactor.data.denominator
            };
        }
        memberClubFee.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);
        memberClubFee.runTime = {
            start: data.runTime.data.start,
            end: data.runTime.data.end,
        };
        memberClubFee.totalPriceWithDiscount = (memberClubFee.pricePerTime.gross.numerator / memberClubFee.pricePerTime.gross.denominator);

        if (data.discount.data) {
            memberClubFee.discount = {
                type: data.discount.data.type,
            };
            if (data.discount.data.type === 'percentage') {
                memberClubFee.discount.name = data.discount.data.name;
            }
            if (data.discount.data.type === 'fixed_price') {
                memberClubFee.discount.price = Price.fromData(data.discount.data.price.data);
                memberClubFee.totalPriceWithDiscount = (memberClubFee.discount.price.gross.numerator / memberClubFee.discount.price.gross.denominator);
            }
        }

        Object.seal(memberClubFee);
        return memberClubFee;
    }

    static fromDataAndSalesListContext(data) {
        if (!data) {
            return;
        }

        let memberClubFee = new MemberClubFee();
        memberClubFee.id = data.id;
        memberClubFee.createdAt = data.createdAt;
        memberClubFee.name = data.name;
        if (null != data.member) {
            memberClubFee.member = {
                id: data.member.id,
                name: data.member.name,
            };
        }
        memberClubFee.creator = {
            id: data.creator.id,
            name: data.creator.name,
        };
        memberClubFee.paymentMethod = data.paymentMethod;
        memberClubFee.quantityFactor = {
            numerator: data.quantityFactor.data.numerator,
            denominator: data.quantityFactor.data.denominator
        };
        memberClubFee.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);
        memberClubFee.category = data.category;
        memberClubFee.chargeCredit = data.chargeCredit;
        memberClubFee.settleWithCredit = data.settleWithCredit;
        memberClubFee.chargeCredit = data.chargeCredit;
        memberClubFee.isDeletable = data.isDeletable;

        return memberClubFee;
    }

}
